<template>
  <div class="tabla-riesgos">
    <el-table
      :cell-class-name="pintar"
      :max-height="700"
      :data="risks"
      :default-sort="{ prop: 'mfl', order: 'descending' }"
      row-class-name="rowClassTablaPloma"
      header-cell-class-name="header-cell-class-table-gray"
    >
      <el-table-column type="expand" width="40">
        <template slot-scope="props">
          <el-row
            :gutter="20"
            style="
              padding-bottom: 20px;
              padding-left: 20px !important;
              padding-right: 20px !important;
            "
          >
            <el-col :sm="props.row.controles_no_criticos ? 6 : 8">
              <h4>{{ $t("Causas") }}</h4>
              <ol>
                <li v-for="(causa, ic) in props.row.causas" :key="ic">
                  {{ causa.nombre }}
                </li>
              </ol>
            </el-col>
            <el-col :sm="props.row.controles_no_criticos ? 6 : 8">
              <h4>{{ $t("Controles Preventivos") }}</h4>
              <ol>
                <li
                  v-for="(control, ic) in getControlesPreventivos(props.row)"
                  :key="ic"
                  :class="tablaControlCritico(control)"
                >
                  {{ control.nombre }}
                </li>
              </ol>
            </el-col>
            <el-col :sm="props.row.controles_no_criticos ? 6 : 8">
              <h4>{{ $t("Controles Mitigatorios") }}</h4>
              <ol>
                <li
                  v-for="(control, ic) in getControlesMitigadores(props.row)"
                  :key="ic"
                  :class="tablaControlCritico(control)"
                >
                  {{ control.nombre }}
                </li>
              </ol>
            </el-col>
            <el-col :sm="props.row.controles_no_criticos ? 6 : 8" v-if="props.row.controles_no_criticos">
              <h4>{{ $t("Controles No Críticos") }}</h4>
              <ol>
                <li
                  v-for="(control, ic) in props.row.controles_no_criticos"
                  :key="ic"
                  :class="tablaControlCritico(control)"
                >
                  {{ control.nombre }}
                </li>
              </ol>
            </el-col>
          </el-row>
          <div
            v-if="props.row.medioambiental"
            style="
              padding-left: 20px !important;
              padding-right: 20px !important;
            "
          >
            <h4>{{ $t("Información Medioambiental") }}</h4>
            <el-row :gutter="20">
              <el-col :sm="12">
                <h5>{{ $t("Responsable") }}</h5>
                {{ props.row.medioambiente.responsable }}
                <h5>{{ $t("Condición") }}</h5>
                {{ props.row.medioambiente.condicion }}
                <h5>{{ $t("Aspecto Ambiental") }}</h5>
                {{ props.row.medioambiente.aspecto }}
              </el-col>
              <el-col :sm="12">
                <h5>{{ $t("Evento") }}</h5>
                {{ props.row.medioambiente.evento }}
                <h5>{{ $t("Equipo Crítico") }}</h5>
                {{ props.row.medioambiente.equipo }}
                <h5>{{ $t("Evaluación Aspecto Ambiental") }}</h5>
                <el-tag
                  :type="
                    getMayorImpacto(props.row).mfl >= 3 ? 'danger' : 'success'
                  "
                >
                  {{
                    getMayorImpacto(props.row).mfl >= 3
                      ? $t("Significativo")
                      : $t("No Significativo")
                  }}
                </el-tag>
              </el-col>
            </el-row>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Riesgo')" sortable>
        <template slot-scope="scope">
          <div class="nombre-riesgo">{{ scope.row.nombre }}</div>
        </template>
      </el-table-column>
      <el-table-column
        width="200"
        :label="$t('Tipo Impacto')"
        min-width="140"
        sortable
      >
        <template slot-scope="scope">
          <ul class="listaImpactos">
            <li
              v-for="(item, index) in scope.row.impactos.map(
                (r) => r.categoria
              )"
              :key="index"
            >
              {{ item }}
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column
        label="MFL"
        prop="mfl"
        width="90"
        align="center"
        sortable
        :sort-method="sortMFL"
      >
        <template slot-scope="scope">
          <span v-bind:type="mflRange(getMayorImpacto(scope.row).mfl)">{{
            getMayorImpacto(scope.row).mfl
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="FS" align="center" width="80" sortable>
        <template slot-scope="scope">{{
          getMayorImpacto(scope.row).impacto.factor_severidad
        }}</template>
      </el-table-column>
      <el-table-column label="FP" align="center" width="80" sortable>
        <template slot-scope="scope">{{
          getMayorImpacto(scope.row).impacto.factor_probabilidad
        }}</template>
      </el-table-column>
      <el-table-column label="RRR" align="center" width="100" sortable>
        <template slot-scope="scope">
          <span>{{ getMayorImpacto(scope.row).rrr }}</span>
        </template>
      </el-table-column>
      <el-table-column label="NSR" align="center" width="80" sortable>
        <template slot-scope="scope">{{
          getMayorImpacto(scope.row).impacto.nivel_severidad
        }}</template>
      </el-table-column>
      <el-table-column label="PDF" align="center" width="300">
        <template slot-scope="scope">
          <div class="text-center">
            <el-button
              v-if="isAdmin() && !$store.getters.user.readonly"
              class="button_img"
              size="small"
              @click="editar(scope.row)"
            >
              <img class="img_pdf" src="@/assets/edit.svg" />
              <br />
              <span>{{ $t("Editar") }}</span>
            </el-button>
            <el-button
              class="button_img"
              size="small"
              @click="imprimirTabla(scope.row._id)"
            >
              <img class="img_pdf" src="@/assets/icons/pdf.png" />
              <br />
              <span>{{ $t("Vista tabla") }}</span>
            </el-button>
            <el-button
              class="button_img"
              size="small"
              @click="imprimirBowtie(scope.row._id)"
            >
              <img class="img_pdf" src="@/assets/icons/pdf.png" />
              <br />
              <span>{{ $t("Vista bowtie") }}</span>
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: ["editRisk", "risks"],
  data() {
    return {
      dialogChangeRiskVisible: false,
      dialogVerificarEstado: false,
      dialogHistoryRiskVisible: false,
      HistoryRisk: {
        props: {
          val: [],
          status_step: 0,
        },
        selected: {},
      },
      actualRisk: "",
      status: {
        status: "",
        status_step: "",
        message: "",
      },
    };
  },
  methods: {
    isAdmin() {
      if (!this.$store.getters.role) return false;
      return this.$store.getters.role.admin || false;
    },
    pintar({ row, column, rowIndex, columnIndex }) {
      let classes = "cellClassTablaPloma ";
      if (columnIndex === 0) {
        if (row.custom === true) {
          classes += "colorCustom";
        } else if (row.impactos[0].categoria === "Seguridad" && !row.custom) {
          classes += "colorSeguridad";
        } else if (row.impactos[0].categoria === "Salud" && !row.custom) {
          classes += "colorSalud";
        } else if (
          row.impactos[0].categoria === "Salud y Seguridad" &&
          !row.custom
        ) {
          classes += "colorSaludySeguridad";
        } else if (
          row.impactos[0].categoria === "Medioambiente" &&
          !row.custom
        ) {
          classes += "colorMedioambiente";
        }
      }
      return classes;
    },
    editar(row) {
      this.editRisk(JSON.parse(JSON.stringify(row)));
    },
    imprimirTabla(id) {
      this.$store.dispatch("getPDFRiesgoTabla", id).then((response) => {
        this.$notify({
          title: "Información",
          message: "PDF Descargado correctamente",
          type: "success",
          offset: 100,
        });
      });
    },
    imprimirBowtie(id) {
      this.$store.dispatch("getPDFRiesgoBowtie", id).then((response) => {
        this.$notify({
          title: "Información",
          message: "PDF Descargado correctamente",
          type: "success",
          offset: 100,
        });
      });
    },
    getControlesPreventivos(risk) {
      const controles = [];
      const controlesId = {};

      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const id = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach((control) => {
              if (!controlesId[control.nombre]) {
                controlesId[control.nombre] = true;
                control.id_causa = id;
                controles.push(control);
              }
            });
          }
        });
      }

      return controles;
    },
    getControlesMitigadores(risk) {
      const controles = [];

      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;

          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach((control) => {
              control.id_impacto = id;
              controles.push(control);
            });
          }
        });
      }

      return controles;
    },
    getMayorImpacto(risk) {
      let mfl = 0;
      let rrr;
      let mayorImpacto;

      if (risk.impactos) {
        risk.impactos.forEach((impacto) => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr =
              (impacto.factor_severidad *
                10 *
                (impacto.factor_probabilidad * 10)) /
              (10 * 10);
            mayorImpacto = impacto;
          }
        });
      }

      return {
        impacto: mayorImpacto,
        mfl,
        rrr,
      };
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return "danger";
      }
      if (mfl === 3) {
        return "warning";
      }
      return "gray";
    },
    sortMFL(a, b) {
      return this.getMayorImpacto(a).mfl >= this.getMayorImpacto(b).mfl;
    },
    tablaControlCritico(risk) {
      return risk.critico ? "control-critico" : "";
    },
  },
};
</script>

<style scoped>
.listaImpactos {
  list-style: none;
  margin: 0px;
  padding: 0px;
  border: 0px;
}

.tabla-riesgos {
  margin-top: 30px;
}

.btn-pdf {
  margin-bottom: 8px;
}

.img_pdf {
  height: 25px;
  margin-bottom: 5px;
}

.button_img {
  vertical-align: middle;
  border: none;
  padding: 0;
  background-color: transparent;
  margin: 10px;
}
</style>
